import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { analytics } from "../utils/analytics";

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.search;
    const title = getPageTitle(location.pathname);

    analytics.pageView(path, title);
  }, [location]);

  return null;
};

const getPageTitle = (pathname: string): string => {
  const titles: Record<string, string> = {
    "/": "Home - Resume-X Landing",
    "/login": "Login - Resume-X",
    "/register": "Register - Resume-X",
    "/verify-email": "Verify Email - Resume-X",
    "/forgot-password": "Forgot Password - Resume-X",
    "/reset-password": "Reset Password - Resume-X",
    "/2fa-verify": "Two-Factor Verification - Resume-X",
    "/privacy-policy": "Privacy Policy - Resume-X",
    "/terms-and-conditions": "Terms & Conditions - Resume-X",
    "/refund-policy": "Refund Policy - Resume-X",
    "/privacy": "Privacy Policy - Resume-X",
    "/terms": "Terms & Conditions - Resume-X",
    "/terms-of-service": "Terms & Conditions - Resume-X",
    "/blog": "Blog - Resume-X",
    "/dashboard": "Admin Dashboard - Resume-X",
    "/editor": "CV Editor - Resume-X",
    "/profile": "Profile - Resume-X",
    "/home": "Dashboard - Resume-X",
    "/my-resumes": "My Resumes - Resume-X",
    "/ai-assistant": "AI Assistant - Resume-X",
    "/ai-cv-builder": "AI CV Builder - Resume-X",
    "/templates": "Templates - Resume-X",
    "/feedback": "Feedback - Resume-X",
    "/devops": "DevOps CV Template - Resume-X",
    "/flutter": "Flutter CV Template - Resume-X",
    "/react": "React CV Template - Resume-X",
    "/software-engineer": "Software Engineer CV Template - Resume-X",
    "/full-stack-developer": "Full Stack Developer CV Template - Resume-X",
  };

  if (pathname.startsWith("/blog/")) {
    return "Blog Post - Resume-X";
  }

  if (pathname.startsWith("/templates/")) {
    return "Template Preview - Resume-X";
  }

  return titles[pathname] || "Resume-X";
};
